<template>
  <el-dialog
    :title="l('邀请子账号')"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="800px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
    :append-to-body="true"
    :modal-append-to-body="true"
  >
    <!-- @closed="$refs.DialogFormData&&$refs.DialogFormData.resetFields()" -->
    <!-- resetFields操作会将每个prop的值重置到mounted时的值 -->
    <!-- before-close 仅当用户通过点击关闭图标或遮罩关闭 Dialog 时起效，因此弃用。 -->
    <el-col class="tip">
      {{l("成功邀请子账号后，该账号会加入")}}<span class="color-warning">{{
        $store.state.session.tenant.name
      }}</span
      >{{l("并享有以下权限")}}：
      <p>1. {{l("发布管理权限，包括商品、求购信息的发布和管理")}}</p>
      <p>2. {{l("论坛交流权限，包括历史信息的管理和新信息的发布")}}</p>
      <p>3. {{l("其他权限， 包括但不限于拼单、客服消息、留言反馈等")}}</p>
    </el-col>
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="l('子账号')" prop="mobile">
            <el-input
              v-model="DialogFormData.mobile"
              :placeholder="l('请输入子账号的手机号')"
              :readonly="status == 2"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="l('图形验证码')" prop="code">
            <el-input
              v-model.trim="DialogFormData.code"
              :placeholder="l('请输入图形验证码')"
              :readonly="status == 2"
            >
              <div slot="suffix" style="height: 0">
                <img
                  v-if="verifyImage"
                  style="width: 120px"
                  :src="verifyImage"
                />
              </div>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="status == 2">
          <el-form-item :label="l('请输入子账号收到的短信邀请码')" prop="verify_code">
            <el-input v-model="DialogFormData.verify_code"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>
      <el-button type="warning" v-if="status == 1" @click="sendCode"
        >{{l("发送短信邀请码")}}</el-button
      >
      <el-button type="primary" v-if="status == 2" @click="inviteStaff"
        >{{l("邀 请")}}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditStaff",
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        mobile: "",
        code: "", //图形验证码
        key: "",
        verify_code: "", //短信邀请码
      },
      dialogRules: {
        mobile: [{ required: true, message: this.l("请输入") + this.l("手机号"), trigger: "blur" }],
        code: [
          { required: true, message: this.l("请输入") + this.l("图形验证码"), trigger: "blur" },
        ],
        verify_code: [
          { required: true, message: this.l("请输入") + this.l("短信邀请码"), trigger: "blur" },
        ],
      },

      status: 1, //1填手机号 2填邀请码

      //图形验证码
      verifyImage: "",
    };
  },

  methods: {
    AfterShow() {
      this.getVerifyImage();
    },
    getVerifyImage() {
      //获取图片验证码
      this.axios.get("/api/verify_code/image/").then((res) => {
        this.verifyImage = res.img;
        this.DialogFormData.key = res.key;
      });
    },
    sendCode() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        this.axios
          .post(`/api/staff/invite/`, this.DialogFormData)
          .then(() => {
            this.status = 2;
          })
          .catch(() => {
            this.getVerifyImage();
          });
      });
    },
    inviteStaff() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        this.axios
          .post(`/api/staff/confirm_invite/`, this.DialogFormData)
          .then(() => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
  },
};
</script>


<style scoped lang="scss">
.tip {
  margin-bottom: 20px;
  margin-left: 10px;
  p {
    text-indent: 20px;
  }
}
</style>

